import React, { useState } from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allVideosHeaders } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AllVideosHooks ,AddVideosHooks} from "./hooks/VideosHooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import AddVideosModal from "./AddvideoModal";
import { useSelector } from "react-redux";

function AllVideos({church}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData, fetchAllVideos } =
    AllVideosHooks();
  const {videoInputs,setVideoInputs}=AddVideosHooks();
   const { userInfo } = useSelector((state) => state.user);

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  // ✅ modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // store row for edit/view

  return (
    <div className="App bg-[#191919] h-fit min-h-screen flex p-4">
      {!hideUI && <Navbar />}

      <div className={`flex-1 ${!hideUI && "md:pl-32"} md:pt-0 pt-20`}>
        <div className="flex flex-col gap-4 h-full">
          {!hideUI && (
            <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
          )}

          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className={`flex w-full ${!hideUI?'justify-between':'justify-end'} md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2`}>
             {!hideUI && <p className=" text-white text-3xl font-medium">Videos</p>}
              <div className="flex gap-4">
                {!hideUI &&
                  <Link to={"/videos/add"}>
                    <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                      <AiOutlinePlus /> Add Video
                    </button>
                  </Link>
           }
              </div>
            </div>

            <div className={`${hideUI && 'relative'}`}>
              { hideUI &&
            <div className="flex gap-4 absolute right-0 mt-2">
            <button
                    onClick={() => {
                      setSelectedRow(null); // new video
                      setIsModalOpen(true);
                    }}
                    className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                  >
                    <AiOutlinePlus /> Add Video
                  </button>
</div>
}
              <CustomTable
                searchFor="Videos"
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                nthChildWidth={
                  "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(3)]:w-32"
                }
                notificationTable={true}
                data={[]}
                headers={allVideosHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllVideos}
                reloadData={reloadData}
                setReloadData={setReloadData}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => (
                      <ConfirmToast
                        title="Are you sure?"
                        message="You want to delete this video?"
                        onClose={() => onClose()}
                        onSuccess={() => {
                          handleDelete(row);
                          onClose();
                        }}
                      />
                    ),
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };
                  confirmAlert(options);
                }}
                reverseTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);
                    // navigate("#", { state: { _id: row?._id || "" } });


                  } else {
                                        navigate("/videos/add", { state: { _id: row?._id || "" } });
                  }
                }}

                handleEditClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);
                  } else {
                    navigate("/videos/add", { state: { _id: row?._id || "" } });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Add Videos Modal (only shows when hideUI === true) */}
      {hideUI && (
        <AddVideosModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedRow(null);
            setReloadData((prev) => !prev); // refresh table
          }}
          rowData={selectedRow}
          hideUI={hideUI}
          church={church}
        />
      )}
    </div>
  );
}

export default AllVideos;
